import { ShieldExclamationIcon } from '@heroicons/react/24/solid';
import { brandColors } from 'brandColors';
import * as React from 'react';

interface Props {
  expanded: boolean;
  width: number;
}

export const DocBlock: React.FC<Props> = (props) => {
  const { expanded, width } = props;
  return (
    <div className="flex flex-col items-center space-y-2 px-2 py-4">
      <ShieldExclamationIcon style={{ height: 22, color: brandColors.colors.gray[600] }} />
      <div
        className="text-center transition"
        style={{ width, position: expanded ? 'inherit' : 'absolute', opacity: expanded ? 1 : 0 }}
      >
        <h5 className="break-all">
          Check our{' '}
          <a
            className="underline"
            target="_blank"
            href="https://www.notion.so/join-bluecargo-ship/BlueCargo-Supported-Shipping-Lines-590699e68e31462a8c95f239c0062b78?pvs=4"
            rel="noreferrer"
          >
            documentation
          </a>{' '}
          for the
          <br />
          list of supported SSL and
          <br />
          terminals
        </h5>
      </div>
    </div>
  );
};
DocBlock.displayName = 'Shipments.DocBlock';
